import { createContext, useContext } from 'react';

type UnitControllerContextType = {
  unitControllerId?: string;
  unitControllerEngineeringId?: string;
};

const UnitControllerContext = createContext<UnitControllerContextType>({});

export const UnitControllerProvider = ({
  children,
  unitControllerId,
  unitControllerEngineeringId,
}: {
  children: React.ReactNode;
  unitControllerId?: string;
  unitControllerEngineeringId?: string;
}) => {
  return (
    <UnitControllerContext.Provider
      value={{ unitControllerId, unitControllerEngineeringId }}
    >
      {children}
    </UnitControllerContext.Provider>
  );
};

export const useUnitController = () => useContext(UnitControllerContext);

export default UnitControllerContext;
